import cn from 'classnames'
import { graphql, useStaticQuery } from 'gatsby'
import { dotPath } from 'ramdasauce'

import { Svg, Text } from 'components/atoms'
import { CONTENTFUL_COLOR } from 'utils/constants'
import { useStyles } from './styles'

export const Footer = ({ footerColor }) => {
  const classes = useStyles()

  const wrapperClasses = cn({
    [classes.wrapper]: true,
    [classes.darkGreen]: footerColor === CONTENTFUL_COLOR.DARK_GREEN,
    [classes.mustard]: footerColor === CONTENTFUL_COLOR.MUSTARD,
    [classes.lightGreen]: footerColor === CONTENTFUL_COLOR.LIGHT_GREEN,
  })

  const data = useStaticQuery(footerQuery)

  return (
    <div className={wrapperClasses}>
      <div className={classes.container}>
        <div className={cn(classes.contentWrapper, classes.content01)}>
          <div className={classes.logoWrapper}>
            <Svg name="simple-logo" className={classes.logo} />
          </div>
        </div>
        <div className={cn(classes.contentWrapper, classes.content02)}>
          <div className={classes.textWrapper}>
            <Text size="footer1" span="h3">
              Find us here
            </Text>
          </div>
          <div className={classes.linksContainer}>
            <a
              className={cn(classes.link, classes.linkInstagram)}
              href={dotPath('sanityFooter.instagramLink', data)}
              target="_blank"
              rel="noreferrer"
            >
              <Svg name="instagram" className={classes.social} />
              <span className={classes.hidden}>Instagram</span>
            </a>
            <a
              className={cn(classes.link, classes.linkYoutube)}
              href={dotPath('sanityFooter.youtubeLink', data)}
              target="_blank"
              rel="noreferrer"
            >
              <Svg name="youtube" className={classes.social} />
              <span className={classes.hidden}>Youtube</span>
            </a>
            <a
              className={cn(classes.link, classes.linkEmail)}
              href={`mailto:${dotPath('sanityFooter.emailAddress', data)}`}
              target="_blank"
              rel="noreferrer"
            >
              <Svg name="email" className={classes.social} />
              <span className={classes.hidden}>Email</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

const footerQuery = graphql`
  query {
    sanityFooter {
      youtubeLink
      instagramLink
      emailAddress
    }
  }
`
